module.exports = __webpack_public_path__ + "img/icono_copy.6acc7633.png";